import React, { Component } from 'react'
import { Text, withLocale } from 'react-localizer'
import { EraToGmMapping } from '../../data/EraToGmMapping'
import LineContainer from './LineContainer'
import Results from './Results'
import { getCurrentEraData } from '../../helper/EraDataHelper'

class ResultsContainerMain extends Component {

  NB_COLUMNS_FROM_P1_TO_END = 6

  constructor (props) {
    super(props)
    this.state = {
      gmName: props.choices.gmChoosen,
      levelMinimum: props.choices.levelChoosen,
      rateP1: props.choices.rateP1Choosen / 100,
      rateP2: props.choices.rateP2Choosen / 100,
      rateP3: props.choices.rateP3Choosen / 100,
      rateP4: props.choices.rateP4Choosen / 100,
      rateP5: props.choices.rateP5Choosen / 100,
      results: [],
      notification: props.notification
    }
  }

  /**
   * Return data fixtures with P2 and P3
   * @param data {[{level : number, maxPf:number, P1:number, P2:number, P3:number, P4:number}]}
   */
  static addOtherRanks (data) {
    for (let level of data) {
      level.P2 = Math.round(level.P1 / 2 / 5) * 5
      level.P3 = Math.round(level.P2 / 3 / 5) * 5
      level.P4 = Math.round(level.P3 / 4 / 5) * 5
      level.P5 = Math.round(level.P4 / 5 / 5) * 5
    }
  }

  /**
   * When component receives new params
   * @param nextProps
   */
  async componentWillReceiveProps (nextProps) {
    this.setState({
      gmName: nextProps.choices.gmChoosen,
      levelMinimum: nextProps.choices.levelChoosen,
      rateP1: nextProps.choices.rateP1Choosen / 100,
      rateP2: nextProps.choices.rateP2Choosen / 100,
      rateP3: nextProps.choices.rateP3Choosen / 100,
      rateP4: nextProps.choices.rateP4Choosen / 100,
      rateP5: nextProps.choices.rateP5Choosen / 100,
      results: await this.calculatesResultsWrapper(nextProps.choices)
    })
  }

  /**
   * See description of calculatesResultsWrapper below
   * @link calculatesResultsWrapper
   * @param item
   * @param gm
   * @param choices
   * @return {Promise<Array>}
   */
  calculatesResults ({item, gm, choices}) {
    let arrResults = [], arrLockable = [], lockableContent = {}, nbColumns = this.NB_COLUMNS_FROM_P1_TO_END

    return Promise.resolve(getCurrentEraData(item.era)
      .then(eraData => {
        //fixtures ranks greater than 1
        ResultsContainerMain.addOtherRanks(eraData)

        const nbLevel = eraData.length
        let currentEraDataLevel
        // loop in each level of eraData
        for (let currentLevel = 1; currentLevel <= nbLevel; currentLevel++) {
          currentEraDataLevel = eraData[currentLevel - 1]
          if (currentLevel >= choices.levelChoosen) {
            // get the lockableContent for each rank
            arrLockable = []
            for (let currentColumn = 1; currentColumn <= nbColumns; currentColumn++) {
              lockableContent = this.getLockableContent(currentEraDataLevel, currentColumn, gm, choices)

              let lockableTooltip = lockableContent.tooltip ? <span className={'lockable'}>{lockableContent.tooltip}</span> : ''
              arrLockable.push(
                <td key={currentColumn}>
                  <span className={lockableContent.styleCSS}>{lockableContent.content}</span>{lockableTooltip}
                </td>)
            }
            arrResults.push(<LineContainer key={currentLevel}
                                           data={{
                                             arrLockable: arrLockable,
                                             level: {level: currentLevel, ...currentEraDataLevel},
                                             promoteLevel: lockableContent.toCopy
                                           }}
                                           notification={this.state.notification}/>)
          }
        }

        return arrResults
      }))
  }

  /**
   * Calculates all the Data
   * @param choices - usually nextProps received from parent component
   * @return {Promise<Array>}
   */
  async calculatesResultsWrapper (choices) {

    for (let item of EraToGmMapping) {
      for (let gm of item.gms) {
        if (gm === choices.gmChoosen) {
          return this.calculatesResults({item, gm, choices})
        }
      }
    }
  }

  /**
   *
   * @param {Object} data {{maxPf, P1}}
   * @param rank
   * @param {String} gm - GM coming from nextProps, not in setState yet
   * @param choices
   * @returns {{styleCSS: string, content: string, tooltip: string}}
   */
  getLockableContent (data, rank = null, gm, choices) {

    let maxPfRemaining = data.maxPf

    /**
     * @type {{
     * toAddForP1,toAddForP2,toAddForP3,toAddForP4,toAddForP5,bonusP1,bonusP2,bonusP3,bonusP4,bonusP5
     * }}
     */
    const dataCalculated = {}
    const promoted = {}
    const maxRank = 5
    for (let place = 1; place <= maxRank; place++) {
      dataCalculated[`bonusP${place}`] = Math.round(data['P' + place] * choices[`rateP${place}Choosen`] / 100)

      dataCalculated[`toAddForP${place}`] =
        // if bonus is 0, then we don't need to add any FP
        (dataCalculated[`bonusP${place}`] === 0)
          ? 0
          : Math.ceil((maxPfRemaining / 2) - dataCalculated[`bonusP${place}`]) * 2
      // toAddForP1 = (toAddForP1 === 1) ? 2 : toAddForP1
      dataCalculated[`toAddForP${place}`] = (dataCalculated[`toAddForP${place}`] === 1) ? 2 : dataCalculated[`toAddForP${place}`]
      // const toBlockP1 = (toAddForP1 > 0) ? toAddForP1 + bonusP1 : bonusP1
      dataCalculated[`toBlockP${place}`] = (dataCalculated[`toAddForP${place}`] > 0)
        ? dataCalculated[`toAddForP${place}`] + dataCalculated[`bonusP${place}`]
        : dataCalculated[`bonusP${place}`]

      // Build the "promoted" variables (copy and paste option)
      promoted[`P${place}`] = dataCalculated[`bonusP${place}`] === 0 ? '' : `P${place}(${dataCalculated[`bonusP${place}`]})`

      maxPfRemaining -= dataCalculated[`toBlockP${place}`]
    }


    /*
    let toAddForP4 = Math.ceil((maxPfRemaining / 2) - bonusP4) * 2
    toAddForP4 = (toAddForP4 === 1) ? 2 : toAddForP4
    */

    const toAddToLockAll = (dataCalculated.toAddForP1 > 0 ? dataCalculated.toAddForP1 : 0)
      + (dataCalculated.toAddForP2 > 0 ? dataCalculated.toAddForP2 : 0)
      + (dataCalculated.toAddForP3 > 0 ? dataCalculated.toAddForP3 : 0)
      + (dataCalculated.toAddForP4 > 0 ? dataCalculated.toAddForP4 : 0)
      + (dataCalculated.toAddForP5 > 0 ? dataCalculated.toAddForP5 : 0)
      // + maxPfRemaining // if we add this, we'll show number of FP to secur and UP once all places are taken !
      //- (dataCalculated.bonusP5 || dataCalculated.bonusP4 || dataCalculated.bonusP3 || dataCalculated.bonusP2)  // to remove last place (usually P5)

    // build the promoted "copy & paste" message
    const {locale} = this.props
    const gmTranslated = locale.get(`gms.${gm}`)

    const promoteLevel = gmTranslated + ` (${data.maxPf}) 👉 ${promoted.P5}${promoted.P5 ? ' ' : ''}${promoted.P4}${promoted.P4 ? ' ' : ''}${promoted.P3} ${promoted.P2} ${promoted.P1}`

    function generateContent (key, value) {
      const keyTranslated = `gmBlockingThreshold.results.${key}`
      return <Text variables={{value: value}}>{keyTranslated}</Text>
    }

    switch (rank) {
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
        if (dataCalculated[`toAddForP${rank}`] > 0) {
          return {
            styleCSS: 'unlockable',
            content: generateContent('unlockable', dataCalculated[`toAddForP${rank}`]),
            tooltip: generateContent('tooltip', dataCalculated[`bonusP${rank}`])
          }
        } else {
          return {
            styleCSS: 'lockable',
            content: generateContent('lockable', dataCalculated[`bonusP${rank}`])
          }
        }
      case 6:
        return {
          styleCSS: 'unlockable',
          content: <div>{generateContent('total', toAddToLockAll)}</div>,
          toCopy: promoteLevel
        }
      default:
        return {
          styleCSS: 'unlockable',
          content: '… Étrange …'
        }
    }
  }

  render () {
    return <Results results={this.state.results}/>
  }
}

const ResultsContainer = withLocale(ResultsContainerMain)

export default ResultsContainer



// WEBPACK FOOTER //
// ./src/components/GmBlockingThreshold/ResultsContainer.js